/**
 * Created by satans17 on 2017/1/5.
 */

export default {
  // 机器人上线
  CHANNEL_ROBOT_ONLINE: 'CHANNEL_ROBOT_ONLINE',
  // 机器人下线
  CHANNEL_ROBOT_OFFLINE: 'CHANNEL_ROBOT_OFFLINE',
  // 人工客服上线
  CHANNEL_OCS_ONLINE: 'CHANNEL_OCS_ONLINE',
  // 仍共客服离线
  CHANNEL_OCS_OFFLINE: 'CHANNEL_OCS_OFFLINE',
  // UI层实例化完成
  VIEW_READY: 'VIEW_READY',
  // APP所有内容初始化完成
  APP_READY: 'APP_READY',
  // 选择订单
  ORDER_SELECT: 'ORDER_SELECT',
  // UI渲染之前
  BEFORE_VIEW_READY: 'BEFORE_VIEW_READY',
  // UI渲染之后
  AFTER_VIEW_READY: 'AFTER_VIEW_READY',
  // 加载历史消息之前
  BEFORE_HISTORY: 'BEFORE_HISTORY',
  // 加载历史消息之后
  AFTER_HISTORY: 'AFTER_HISTORY',

  NO_AGENT_SESSION: 'NO_AGENT_SESSION',
  SHOW_FEEDBACK: 'SHOW_FEEDBACK',
  SUBMIT_FEEDBACK: 'SUBMIT_FEEDBACK',
  DONE_FEEDBACK: 'DONE_FEEDBACK',

  AGENT_END_CHAT: 'AGENT_END_CHAT',

  CANCEL_UPLOAD_FILE: 'CANCEL_UPLOAD_FILE',
  REMOVE_CANCELLED_FILE: 'REMOVE_CANCELLED_FILE',
  UPLOADING_FILE: 'UPLOADING_FILE',
  FINISH_UPLOAD_FILE: 'FINISH_UPLOAD_FILE',
  DISABLE_UPLOAD: 'DISABLE_UPLOAD',
};



// WEBPACK FOOTER //
// ./src/app/context/app_events.js